/**
 * @desc 临时处理
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.outPlanMaster.temp.Params, options?: any) {
  return updateResponse(
    http(URL + `/outPlanMaster/temp`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
